$(function() {

  

    var sliderOpts = {
        animation: 'slide',
        animationSpeed: 500,
        pauseOnHover: true,
        keyboard: false,
        slideshow: true,
        slideshowSpeed: 5000,
        directionNav: true,
        startAt: 0
    }

    // Initialize slider on docready

    $(window).on('load', function () {

        var $slider = $('.flexslider');

        if ($slider.length) {

            if ($slider.find('li').length === 1) {
                sliderOpts.slideshow = false;
                sliderOpts.slideshowSpeed = 0;
                sliderOpts.controlNav = false;
                sliderOpts.directionNav = false;
            }

            setTimeout(function () {
                $slider.flexslider(sliderOpts).show();
                //$slider.find('li').removeClass('hidden');
            }, 2000);
        }

    });

  

  

    var productSliderOpts = {
        animation: 'slide',
        animationSpeed: 500,
        pauseOnHover: true,
        keyboard: false,
        slideshow: false,
        slideshowSpeed: 3000,
        itemWidth: 210,
        itemMargin: 30,
        minItems: 1,
        maxItems: 5,
        randomize: true
    }

    // Initialize slider on docready



    var $productSlider = $('.product-slider');

    if ($productSlider.length) {

        if ($productSlider.find('li').length === 4) {
            productSliderOpts.slideshow = false;
            productSliderOpts.slideshowSpeed = 0;
            productSliderOpts.controlNav = false;
            productSliderOpts.directionNav = false;
        }


        setTimeout(function () {
            $productSlider.flexslider(productSliderOpts).show();
        }, 0); //to update delivery price when flexslider is initialized
    }


  

    var $storePhotoSlider = $('.store_photo_slider');
    if ($storePhotoSlider.length > 0) {
        var storePhotoSliderOpts = {
            //keyboard: false,
            //slideshow: false,
            //slideshowSpeed: 0,
            //controlNav: false,
            //directionNav: false,
            //itemWidth: 210,
            //itemMargin: 30,
            //minItems: 1,
            //maxItems: 3

            animation: 'slide',
            animationSpeed: 500,
            pauseOnHover: true,
            keyboard: false,
            slideshow: false,
            slideshowSpeed: 500,
            itemWidth: 240,
            itemMargin: 10,
            minItems: 1,
            maxItems: 5,
            randomize: false
        };

        //if ($storePhotoSlider.find('li').length > 3) {
        //    storePhotoSliderOpts.animation = 'slide';
        //    storePhotoSliderOpts.animationSpeed = 500;
        //    storePhotoSliderOpts.pauseOnHover = true;
        //    storePhotoSliderOpts.slideshow = true;
        //    storePhotoSliderOpts.slideshowSpeed = 3500;
        //}

        setTimeout(function () {
            $storePhotoSlider.flexslider(storePhotoSliderOpts);
        }, 0);
    }

});